import { Button } from '@arcadiapower/shrike';
import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

export const StyledButton = styled(Button)<SpaceProps>`
  ${space}
`;

export const FaqButton = styled(Button)`
  width: 40%;
  margin-bottom: 2rem;
  padding: 0.5rem;
  align-self: flex-start;
  display: none; // By default, the button is not displayed
  ${props => props.theme.media.tabletLandscapeDown} {
    display: block; // Only show the button in this desktop/tablet
  }
`;
